import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BCIHero from './components/BCIHero';
import MetodologiaSection from './components/MetodologiaSection';
import ProprietaIntellettuale from './components/ProprietaIntellettuale';
import ComparazioneMetodi from './components/ComparazioneMetodi';
import AlgoritmoSection from './components/AlgoritmoSection';
import CertificazioniSection from './components/CertificazioniSection';
import CTASection from './components/CTASection';
import { useSEO } from '../../utils/seo';

export function BCIPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://brandcapital.it';
  
  useSEO({
    title: 'BCI - Brand Capital Index: Algoritmo Certificato Valutazione Brand',
    description: 'Il Brand Capital Index (BCI) è l\'algoritmo proprietario certificato che integra tutti gli indicatori di valore del brand. Metodologia scientifica riconosciuta per perizie difendibili e valutazioni certificate.',
    keywords: 'BCI, brand capital index, algoritmo valutazione brand, metodologia certificata, perizia brand',
    canonical: `${siteUrl}/bci`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: 'Brand Capital Index (BCI) - Algoritmo Certificato per la Valutazione del Brand',
      description: 'Il Brand Capital Index è l\'algoritmo proprietario che integra tutti gli indicatori di valore del brand',
      author: {
        '@type': 'Organization',
        name: 'Brand Capital'
      },
      publisher: {
        '@type': 'Organization',
        name: 'Brand Capital',
        logo: {
          '@type': 'ImageObject',
          url: `${siteUrl}/logo.png`
        }
      },
      datePublished: '2024-01-01',
      dateModified: new Date().toISOString().split('T')[0]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <BCIHero />
      <MetodologiaSection />
      <AlgoritmoSection />
      <ComparazioneMetodi />
      <ProprietaIntellettuale />
      <CertificazioniSection />
      <CTASection />
      <Footer />
    </div>
  );
}

export default BCIPage;
